import Header from "./header/Header";
import Footer from "./footer/Footer";
import SidePanel from "./sidepanel";
export default {
    Header,
    Footer,
    SidePanel
}